import { render } from "./index.vue?vue&type=template&id=157c0a9e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/setting/departmentManagement/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "157c0a9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('157c0a9e', __exports__)) {
    console.log('reload')
    api.reload('157c0a9e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=157c0a9e", () => {
    console.log('re-render')
    api.rerender('157c0a9e', render)
  })

}


export default __exports__